var boostPFSInstantSearchConfig = { search: { suggestionMobileStyle: "style2", productAvailable: !1 } };
!(function () {
    BoostPFS.inject(this), 
            InstantSearchApi.beforeCall = function(searchTerm) {    
                /* Change the params before calling api */    
                Globals.instantSearchQueryParams.sort_first = 'available'; 
              }
      jQ(document).on('paste','.search-bar__input',function(){
        jQ(this).click();
      
      });

      SearchInput.prototype.customizeInstantSearch = function (t, o, e) {
      }
      
  
  
       SearchInput.prototype._onSubmit = function(event, redirect) {
          if (isDisabledInstantSearch) return;

            if (typeof redirect == 'undefined') {
              redirect = this.isChangePage;
            }
            this.isChangePage = false;

            if (!redirect) {
              // Stop all default submit events
              event.stopImmediatePropagation();
              event.stopPropagation();
              event.preventDefault();
              // Fix case can not get current value from input
              Globals.currentTerm = Utils.stripHtml(this.$element.val());
              if (!Globals.currentTerm && event && event.target) {
                Globals.searchTerm = Utils.stripHtml(event.target.value);
              }
              var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();

              // if API returned results or the suggestionCache has the search term, submit search
              // else: add the data-search-submit attribute to the search input box, wait for the api returns the result,
              // then remove this attribute in the checkForSearchRedirect function
              var query = Utils.unescape(Globals.currentTerm);
              query = query.trim().replace(/\s+/g, ' ');
              var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);
              // Set recent searches
              InstantSearchOnclick.setOnClickRecentSearches(query);
              // If the API returned results, either redirect or perform submit
              if (isApiReturnedResult) {
                if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
                  Utils.setWindowLocation(redirectUrl);
                } else {
                  this.isChangePage = true;
                  this.$searchForm[0].submit();
                }
              } else if (Globals.currentTerm) {
                // If the API hasn't returned results, set data-search-submit on the search input and wait
                this.$element.data('search-submit', true);
              } else {
                this.isChangePage = true;
                this.$searchForm[0].submit();
              }
            }
      }
})();

